module.exports = __webpack_public_path__ + "static/media/molinera_eldiluvio.be9fa330.png";